@for (group of steps; track group.type) {
    <h4 class="group-header">
        {{ getTypeTranslationKey(group.type) | translateTokenisedString }}
    </h4>
    <div wdxListGroup [wdxListGroupFlush]="true" class="info-card-container">
        @for (step of group.steps; track step.code + $index) {
            <button
                wdxListGroupItem
                [wdxListGroupAction]="true"
                [disabled]="step.isDisabled ?? false"
                type="button"
                class="step-button-container text-truncate"
                (click)="onStepClicked(step)"
            >
                <wdx-info-card [flush]="true" class="workflow-step">
                    <div wdxInfoCardLeading>
                        <wdx-icon-container
                            class="bg-icon workflow-step-icon"
                            size="lg"
                        >
                            <wdx-icon [icon]="step.icon"></wdx-icon>
                        </wdx-icon-container>
                    </div>
                    <div wdxInfoCardLabel>
                        {{ step.name?.key | translateTokenisedString }}
                    </div>
                    <div wdxInfoCardSub>
                        {{ step.description?.key | translateTokenisedString }}
                    </div>
                    <div wdxInfoCardTrailing></div>
                </wdx-info-card>
            </button>
        }
    </div>
}
